import React from "react";

export type Events = {
    id: number;
    starts: string;
    home_team: { name: string };
    away_team: { name: string };
    market: {
        line_name: string | undefined;
        market_code: string;
        market_name: string;
        bets: { id: number; bet_code: string; bet_name: string; odds: number }[];
    };
};
export type SwipedMarket = {
    event_id: number;
    bet_id: number;
    odds: number;
    market_name: string;
    market_code: string;
    bet_name: string;
    home_team: { name: string };
    away_team: { name: string };
};
export interface SMI {
    clearPaystackSession: () => void,
    setHidePaystack: () => void,
    initPaystack: () => void,
    hidePaystack: boolean,
    paystackToken: string
    markets: Events[],
    onSwipeEventIndex?: (number: number) => void,
    setShowSettingsModal?: (toggle: boolean) => void,
    highlightOdds?: number | null
    currentEventIndex?: number,
    marketsCount?: any,
    selectedMarkets?: any
    showPaymentBlock?:boolean,
    makeMarketVisible?: (toggle: boolean) => void;
    styles: any,
    operator: string,
    handeTest: (markets: any[]) => void,
    handleChangeNumber: (number: string) => void;
    data: any
    currency: string
    sessionToken: string
    paramsToken?: string | null
    lang?: string | null
    atag?: string | null
    rtag?: string | null
    isAuth: boolean
    ticketSummary: any
    stakeBet: () => void;
    initBrite?: () => void;
    clearBriteSession?: () => void;
    skipEvent?: (event: any) => void;
    eventToShow?: any
    triggerRedirectToTrack?: () => void;
    psp?: string[];
    language: string,
    languages: string[]
    id?: string
    setBet?: (obj: any) => void;
    price?: number;
    setStake?: (stake: number) => void;
    setPrice?: (stake: number) => void;
}
type SwipeDirection = "left" | "right" | "down" | "up";
export type CardPropsQuickbetX = {
    markets: any[];
    highlightOdds?: number | null;
    currentIndex: number;
    swipedMarkets: any[];
    styles: any;
    eventToShow?: any;
    skipEvent?: (event: any) => void;
    childRefs: React.RefObject<any>[];
    onSwipe: (direction: SwipeDirection, market: any, index: number) => void;
    onCardLeftScreen: (marketId: number, index: number) => void;
    swipe: (dir: SwipeDirection) => void;
};
export type CardProps = {
    markets: any[];
    operator?: string;
    swipedMarkets: any[];
    styles: any;
    childRefs: React.RefObject<any>[];
    onSwipe: (direction: string, market: any, index: number) => void;
    onCardLeftScreen: (marketId: number, index: number) => void;
    swipe: (dir: "left" | "right" | "down") => void;
};

export const operatorPlaceholders: Record<string, string> = {
    'premierbet-demo': 'Enter mobile number (44xxxx)',
    'betika-demo': 'Enter mobile number (254xxxx)',
    'odibets-demo': 'Enter mobile number (254xxxx)',
    'mozzartbet-demo': 'Enter mobile number (254xxxx)',
    'sportpesa-demo': 'Enter mobile number (07xxxx)',
    '888-demo': 'Enter mobile number (255xxxx)',
    'sportsloth': 'Enter mobile number 07XX',
    'mzukabet-ke': 'Enter mobile number (07xxxx)',
    'mzukabet-tz': 'Enter mobile number (07xxxx)',
    'mshikebet-ke': 'Enter mobile number (07xxxx)',
    'hallabet-ng':'070xxx, 080xxx, 081xxx'
};
export const hiddenOperatorsSlider = ['sportsloth', 'mzukabet-tz','hallabet-ng', 'mzukabet-ke', 'eurowin', 'tipico-demo', 'daznbet-demo', 'bet365-demo', 'interwetten-demo', 'mshikebet-ke'];